export default "__VITE_ASSET__C5ds8nG___"